/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {ProductFinderRowSkeleton} from "./ProductFinderRowSkeleton";

export const ProductFinderSkeleton = () => (
    <div className="row">{[...Array(3)].map((item, i) => <ProductFinderRowSkeleton key={i}/>)}</div>
)
